'use strict'

module.exports = function( url, callback ){

  var maxDim = window.lsrIsMobile ? 1024 : 2048;
  
  var canvas = document.createElement('canvas');
  
  var ctx = canvas.getContext('2d');
  
  canvas.width = canvas.height = 64;

  var tex = new THREE.Texture(canvas);
  tex.needsUpdate = true;

  var img = new Image();
  
  img.onload = function(){

    canvas.width = Math.min(img.width, maxDim);
  
    canvas.height = Math.min(img.height, maxDim);
  
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
  
    tex.needsUpdate = true;

    if(callback)  callback(tex);
  
  }

  img.onerror=function(){
    console.log( 'ERROR', e, url  );
  };

  img.crossOrigin = "";
  
  img.src = url;

  return tex;
}